// API Response types for structured error handling

import { SUCCESS_CODE } from './error_codes';

// Generic API response structure
export interface ApiResponse<T = any> {
  Code: string;
  Msg: T | string;
}

// Type guard to check if response is an error
export function isErrorResponse(response: ApiResponse): response is ApiResponse<string> {
  return response.Code !== SUCCESS_CODE;
}

// Type guard to check if response is successful
export function isSuccessResponse<T>(response: ApiResponse<T>): response is ApiResponse<T> {
  return response.Code === SUCCESS_CODE;
}

// Extract data from successful response
export function getResponseData<T>(response: ApiResponse<T>): T {
  if (isErrorResponse(response)) {
    throw new Error(response.Msg as string);
  }
  return response.Msg as T;
}

// Extract error message from error response
export function getErrorMessage(response: ApiResponse): string {
  if (!isErrorResponse(response)) {
    return '';
  }
  return response.Msg as string;
}